import { render, staticRenderFns } from "./EloadSpecialCategoryForm.vue?vue&type=template&id=65baae02&scoped=true"
import script from "./EloadSpecialCategoryForm.vue?vue&type=script&lang=js"
export * from "./EloadSpecialCategoryForm.vue?vue&type=script&lang=js"
import style0 from "./EloadSpecialCategoryForm.vue?vue&type=style&index=0&id=65baae02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65baae02",
  null
  
)

export default component.exports